import { Observable } from "rxjs";
import { StateService } from "./stateService";

export type MenuCommand = "New" | "Edit" | "Delete" | "Copy" | "QS-Test" | "Save" | "Cancel" | "None" | "SaveNew"

export interface MenuCommandState {
    command: MenuCommand
    receiver: string | undefined
    rowId: number | undefined
    hirarchie: number | undefined
    clickedRowIdWhenNew: number | undefined
  }

  
const initialState: MenuCommandState = {
    command: "None",
    receiver: undefined,
    rowId: undefined,
    hirarchie: undefined,
    clickedRowIdWhenNew: undefined
}


export class StammdatenReceiverServiceForRoot extends StateService<MenuCommandState>{
    public static service: StammdatenReceiverServiceForRoot;
    
    public static getMenuCommandService() : StammdatenReceiverServiceForRoot {
        if ( this.service === undefined) {
            this.service = new StammdatenReceiverServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);
    }
    
    public subscription(): Observable<MenuCommandState> {
        return this.subscribe();
    }

    public reset() {
        this.changeState({receiver: undefined, command: "None", rowId: undefined, hirarchie: undefined, clickedRowIdWhenNew: undefined});   
    }

    public changeMenuCommandState(menuCommand: MenuCommandState) : void {       
        this.changeState(menuCommand);        
    }

    public get commandState(): MenuCommandState {
        return this.state;
    }
}